import React from "react";
import Select from "react-select";
import {ModalShell} from "../ui/ModalShell";
import {CITY_OPTIONS, STORE_OPTIONS} from "../constants";
import {SelectOption, WarehouseFormRow, ModalMode} from "../types";
import {BtnSpinner} from "../../../../components/fields/BtnSpinner";

export function TypeModal({
                              mode,
                              typeTitle,
                              setTypeTitle,
                              typeOzon,
                              setTypeOzon,
                              typeWarehouses,
                              onAddWarehouseRow,
                              onUpdateWarehouseRow,
                              onRemoveWarehouseRow,
                              onClose,
                              onSubmit,
                              isSaving,
                              selectMenuPortal,
                          }: {
    mode: ModalMode;

    typeTitle: string;
    setTypeTitle: (v: string) => void;

    typeOzon: boolean;
    setTypeOzon: (v: boolean) => void;

    typeWarehouses: WarehouseFormRow[];
    onAddWarehouseRow: () => void;
    onUpdateWarehouseRow: (idx: number, patch: Partial<WarehouseFormRow>) => void;
    onRemoveWarehouseRow: (idx: number) => void;

    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    isSaving: boolean;

    selectMenuPortal: any;
}) {
    return (
        <ModalShell onClose={onClose}>
            <h2 className="supplies-modal-title">
                {mode === "create" ? "Добавить тип (структура)" : "Изменить тип (структура)"}
            </h2>

            <form className="supplies-form" onSubmit={onSubmit}>
                <div className="admin-field">
                    <div className="admin_title">Название</div>
                    <input className="admin-input" value={typeTitle} onChange={(e) => setTypeTitle(e.target.value)}/>
                </div>

                <div className="admin-field">
                    <label className="admin_checkbox">
                        <input type="checkbox" checked={typeOzon} onChange={(e) => setTypeOzon(e.target.checked)}/>
                        <span style={{marginLeft: 8}}>Ozon / ЯМ / ТК</span>
                    </label>
                </div>

                <div className="admin-field">
                    <div className="admin_title">Склады</div>

                    <div className="supplies-warehouse-note" style={{marginTop: 6, fontSize: 12, opacity: 0.85}}>
                        <b>Каждый склад добавляйте в новой строке</b> (кнопка «+ Добавить склад»).
                    </div>
                    <div className="supplies-warehouse-note" style={{marginTop: 6, fontSize: 12, opacity: 0.85}}>
                    </div>
                    <div className="supplies-warehouses-list">
                        {typeWarehouses.map((row, idx) => (
                            <div className="supplies-warehouse-row" key={idx}>
                                <div className="admin-field supplies-warehouse-col">
                                    <div className="admin_title">Название</div>
                                    <input
                                        className="admin-input"
                                        value={row.warehouseName}
                                        onChange={(e) => onUpdateWarehouseRow(idx, {warehouseName: e.target.value})}
                                    />
                                    <div className="supplies-warehouse-note">Отображается в форме заявки</div>
                                </div>

                                <div className="admin-field supplies-warehouse-col">
                                    <div className="admin_title">Склад</div>
                                    <Select
                                        {...selectMenuPortal}
                                        options={STORE_OPTIONS}
                                        value={row.store}
                                        onChange={(v) => onUpdateWarehouseRow(idx, {store: v as any})}
                                        classNamePrefix="supplies-select"
                                    />
                                </div>

                                <div className="admin-field supplies-warehouse-col">
                                    <div className="admin_title">Город отправки</div>
                                    <input
                                        className="admin-input"
                                        value={row.sendCity}
                                        onChange={(e) => onUpdateWarehouseRow(idx, {sendCity: e.target.value})}
                                    />
                                    <div className="supplies-warehouse-note">Указывайте с большой буквы, отображается в
                                        калькуляторе и направлениях
                                    </div>
                                </div>

                                <div className="admin-field supplies-warehouse-col">
                                    <div className="admin_title">Цена за куб</div>
                                    <input
                                        className="admin-input"
                                        inputMode="numeric"
                                        value={row.price}
                                        onChange={(e) => onUpdateWarehouseRow(idx, {price: e.target.value})}
                                    />
                                    <div className="supplies-warehouse-note">
                                        Если цена для города отправления <b>уже существует</b>, то цена <b>не
                                        изменится</b>. Чтобы изменить
                                        цену, нужно изменить ее в админке «Направления».
                                    </div>
                                </div>

                                <div className="supplies-warehouse-remove">
                                    <button
                                        type="button"
                                        className="admin-button-secondary admin-button-secondary--ghost"
                                        onClick={() => onRemoveWarehouseRow(idx)}
                                        disabled={typeWarehouses.length <= 1}
                                    >
                                        Удалить
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        type="button"
                        className="admin-button-secondary admin-button-secondary--ghost supplies-add-warehouse-btn"
                        onClick={onAddWarehouseRow}
                    >
                        + Добавить склад
                    </button>
                </div>

                <div className="supplies-modal-actions">
                    <button type="button" className="admin-button-secondary admin-button-secondary--ghost"
                            onClick={onClose} disabled={isSaving}>
                        Отмена
                    </button>
                    <button type="submit" className="admin-button-primary" disabled={isSaving}>
                        {isSaving ? (
                            <BtnSpinner/>
                        ) : (
                            "Сохранить"
                        )}
                    </button>
                </div>
            </form>
        </ModalShell>
    );
}
